const timeout = 0;

export const lStorage = {
  get(key) {
    return new Promise((resolve) =>
      setTimeout(() => {
        const string = window.localStorage.getItem(key);
        resolve(string ? JSON.parse(string) : null);
      }, timeout)
    );
  },
  set(key, value) {
    return new Promise((resolve) =>
      setTimeout(() => {
        resolve(window.localStorage.setItem(key, JSON.stringify(value)));
      }, timeout)
    );
  },
};
